const localTime = () => {
  const timeEl = document.getElementById('js-local-time')

  if (!timeEl) return

  const secHand = document.querySelector('#js-second'),
    minhand = document.querySelector('#js-minute'),
    hrhand = document.querySelector('#js-hour'),
    output = document.getElementById('js-timezone'),
    timezone = output.dataset.timezone

  const updateTime = () => {
    const currentTime = new Date()
      .toLocaleString('en-US', { timeZone: `${timezone}` })
      .split(',')[1]
    const segment = currentTime.split(':')

    const hr = segment[0]
    const m = segment[1]
    const s = segment[2].split(' ')[0]

    // Random unicode characters keep appearing through the time
    // U+202f ' '
    // U+0020

    output.textContent = currentTime

    secHand.classList.toggle('hand-transition', s != 0)

    const sethrdeg = (360 * hr) / 12 + (360 * m) / (12 * 60) + 90
    hrhand.style.transform = `rotate(${sethrdeg}deg)`

    const setmdeg = (360 * m) / 60 + (360 * s) / (60 * 60) + 90
    minhand.style.transform = `rotate(${setmdeg}deg)`

    const setsdeg = (360 / 60) * s + 90 // 6 * s;
    secHand.style.transform = `rotate(${setsdeg}deg)`
  }

  setInterval(() => updateTime(), 1000)
}

export default localTime
